// extracted by mini-css-extract-plugin
module.exports = {"AnswersBlock":"AnswersBlock_AnswersBlock__1iF8y"};